var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { OnInit } from '@angular/core';
export class PasswordFormPageComponent {
    constructor(auth, route, router) {
        this.auth = auth;
        this.route = route;
        this.router = router;
        this.codeError = false;
        this.updateError = false;
        this.updateSuccess = false;
        this.form = new FormGroup({
            password: new FormControl('', Validators.required)
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.mode = this.route.snapshot.queryParamMap.get('mode');
            this.code = this.route.snapshot.queryParamMap.get('oobCode');
            this.apiKey = this.route.snapshot.queryParamMap.get('apiKey');
            this.continueUrl = this.route.snapshot.queryParamMap.get('continueUrl');
            if (this.mode === 'resetPassword' && this.code && this.apiKey) {
                try {
                    this.email = yield this.auth.auth.verifyPasswordResetCode(this.code);
                    console.log(this.email);
                }
                catch (e) {
                    console.log(e);
                    this.codeError = true;
                }
            }
            else {
                this.codeError = true;
            }
        });
    }
    updatePassword() {
        return __awaiter(this, void 0, void 0, function* () {
            const password = this.form.value.password;
            try {
                yield this.auth.auth.confirmPasswordReset(this.code, password);
                if (this.continueUrl) {
                    location.href = this.continueUrl;
                }
                else {
                    const user = yield this.auth.auth.signInAndRetrieveDataWithEmailAndPassword(this.email, password);
                    this.updateSuccess = true;
                }
            }
            catch (e) {
                alert(e);
                this.updateError = true;
            }
        });
    }
}
